export enum CATEGORY_TYPES {
    SE_EXPENSE = 'SE_EXPENSE',
    SE_INCOME = 'SE_INCOME',
    NON_FHL_LL_EXPENSE = 'NON_FHL_LL_EXPENSE',
    NON_FHL_LL_INCOME = 'NON_FHL_LL_INCOME',
    FHL_LL_EXPENSE = 'FHL_LL_EXPENSE',
    FHL_LL_INCOME = 'FHL_LL_INCOME'
}
